export default __webpack_public_path__ + "static/media/granadata.e4b06cb7.png";